import React from 'react';
import Text from '../../../../BaseModule/Components/Text';
import styles from './WizardText2.module.scss';
import NoEscape from '../../../../../Utils/NoEscape';
import { WizardItemSubType } from '../../../Enums/WizardItemSubtype.enum';
import { WizardItem } from '../../../Interfaces/Wizard.interface';
import { WizardItemType } from '../../../Enums/WizardItemType.enum';

interface Props {
	item: Extract<WizardItem, { type: WizardItemType.TEXT }>;
	customStyle?: React.CSSProperties;
}

const WizardText: React.FC<Props> = ({ item, customStyle }) => {
	const settings = item.settings;
	const style: React.CSSProperties = customStyle ?? {
		fontSize: settings?.size,
		color: settings?.color,
		textAlign: settings?.alignCenter ? 'center' : undefined,
		...(settings?.style ?? {}),
	};

	switch (item.subtype) {
		case WizardItemSubType.HEADER:
			return <Text tx={item.title} className={styles.header} style={style} />;
		case WizardItemSubType.HTML:
			return <NoEscape children={item.title} style={style} />;
		case WizardItemSubType.NORMAL:
		default:
			return <Text tx={item.title} className={styles.normal} style={style} />;
	}
};

export default WizardText;
